import { ROUTES } from 'src/constants/routes.const';
import { applyFutureLearnablesOffset } from 'src/utils/futureLearnablesOffset';
import { stringifyUrl } from 'src/utils/stringifyUrl';

export type SentenceBuildingSessionUrlOptions = {
  source?: string;
  pathwayNodeId?: number;
  pathwayCheckpointId?: number;
  futureLearnablesOffset?: number;
};

export const getSentenceBuildingSessionUrl = (
  languagePairId: number,
  options: SentenceBuildingSessionUrlOptions = {},
): string => {
  const params: Record<string, string | number> = { language_pair_id: languagePairId };
  if (options.source) {
    params.source = options.source;
  }
  if (options.pathwayNodeId !== undefined) {
    params.pathway_node_id = options.pathwayNodeId;
  }
  if (options.pathwayCheckpointId !== undefined) {
    params.pathway_checkpoint_id = options.pathwayCheckpointId;
  }
  applyFutureLearnablesOffset(params, options.futureLearnablesOffset);
  return stringifyUrl(ROUTES.aprender.cloze, params);
};
